/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const indigo = {
    50: '#E0E9FF',
    100: '#C2D3FF',
    200: '#9CB9FF',
    300: '#81A5FF',
    400: '#6692FF',
    500: '#5586FF',
    600: '#406DDD',
    700: '#2E56BB',
    800: '#1F4299',
    900: '#132F77',
    1000: '#091F55',
};
